import { Contact, Address, ProductServiceItem, Vendor, Customer,  } from 'src/app/shared/models/accounting';
import { FFL } from 'src/app/shared/models/general';
import { AccountingService } from '../services/accounting.service';

export function getContactModelProperties(): string[] {
  const contact:Contact = new Contact();
  return Object.keys(contact) as Array<keyof Contact>;
}

export function getAddressModelProperties(): string[] {
  const address:Address = new Address();
  return Object.keys(address) as Array<keyof Address>;
}

export function getFflModelProperties(): string[] {
  const ffl:FFL = new FFL();
  return Object.keys(ffl) as Array<keyof FFL>;
}

export function getProductServiceModel(): string[] {
  const product_service_item:ProductServiceItem = new ProductServiceItem();
  const keys = Object.keys(product_service_item) as Array<keyof ProductServiceItem>;
  keys.splice(keys.indexOf('id'), 1);
  return keys;
}

export const transformVendorToPlainObject = (vendor: Vendor): any => {
  return {
    id: vendor.id,
    contact_id: vendor.contact_id,
    contact_type: vendor.contact_type,
    contact: {
      company_name: vendor.contact.company_name,
      display_name: vendor.contact.display_name,
      name_title: vendor.contact.name_title,
      name_first: vendor.contact.name_first,
      name_middle: vendor.contact.name_middle,
      name_last: vendor.contact.name_last,
      name_suffix: vendor.contact.name_suffix,
      email: vendor.contact.email,
      phone_number: vendor.contact.phone_number,
      fax_number: vendor.contact.fax_number,
      website: vendor.contact.website,
      name_to_print_on_checks: vendor.contact.name_to_print_on_checks,
      other: vendor.contact.other,
    },
    address: {
      street: vendor.address?.street || null,
      street2: vendor.address?.street2 || null,
      city: vendor.address?.city || null,
      state: vendor.address?.state || null,
      zip_code: vendor.address?.zip_code || null,
      country: vendor.address?.country || null,
    },
    ach_payments: {
      account_number: vendor.ach_payments?.account_number || null,
      routing_number: vendor.ach_payments?.routing_number || null,
    },
    memo: vendor.memo,
    attachments: vendor.attachments || [],
    ffl: {
      ffl: vendor.ffl?.ffl || null,
      legal_name: vendor.ffl?.legal_name || null,
      business_name: vendor.ffl?.business_name || null,
      phone_number: vendor.ffl?.phone_number || null,
      email: vendor.ffl?.email || null,
      notes: vendor.ffl?.notes || null,
      expiration_date: vendor.ffl?.expiration_date || null,
    },
  };
};

export const sortByDisplayName = (items: any[]): any[] => {
  return items.sort((a, b) =>
    a.contact.display_name.trim().localeCompare(b.contact.display_name.trim())
  );
};
export function findInventoryItemByUpc(upc: string, accountingService: AccountingService): ProductServiceItem | null{
  const item = accountingService.products_services.filter(
      (item) => item['upc'] === upc
    )[0]
  return item
}
export function findInventoryItemByName(name: string, accountingService: AccountingService): ProductServiceItem | null {
  const item = accountingService.products_services.filter(
      (item) => item['name'] === name
    )[0]
  return item
}
export function findInventoryItemById(id: string, accountingService: AccountingService): ProductServiceItem | null {
  const item = accountingService.products_services.filter(
      (item) => item.id === id
    )[0]
  return item
}
export function getCustomerById(id: string, accountingService: AccountingService): Customer {
  const customer =  accountingService.customers.filter(
    (customer) => customer.id === id
  )[0]
  return customer
}
export function getProductServiceType(product_service: string, accountingService: AccountingService): string {
const item_type = accountingService.products_services.filter(
      (item) => item.name === product_service
    )[0]
    console.warn(item_type);
  return item_type.type
}
export function  isProduct(item: string, accountingService: AccountingService) {
    if (getProductServiceType(item, accountingService) === 'Service') {
      return false;
    } else {
      return true;
    }
  }